<script setup lang="ts">
    withDefaults(
        defineProps<{
            bordered?: boolean;
            disableHover?: boolean;
            label?: string;
        }>(),
        {
            label: undefined,
            bordered: true,
            disableHover: false,
        },
    );
    const active = defineModel<boolean>({ default: false });

    function toggleActive() {
        active.value = !active.value;
    }
</script>

<template>
    <button
        type="button"
        @click="toggleActive"
    >
        <!-- When active, shadow-inner is used for reducing the pixelated effect on the border -->
        <div
            data-test-id="toggle-button"
            :class="[
                active && 'border-border-secondary bg-bg-primary text-white',
                !active && 'bg-white text-text',
                bordered && !active && 'border border-secondary',
                active && !disableHover && 'hover:border-border-secondary hover:bg-bg-primary hover:text-white',
                !active && !disableHover && 'hover:border-hover-primary hover:bg-hover-primary hover:text-white',
                'transition-color m-auto h-8 w-8 overflow-hidden duration-300',
            ]"
        >
            <slot />
        </div>

        <span v-if="label">{{ label }}</span>
    </button>
</template>
